import * as classes from "./object-sticky-label.module.scss";
// import IconCL from "../../icons/IconCL.svg";
// import IconFT from "../../icons/IconFT.svg";
// import IconFF from "../../icons/IconFF.svg";
import LookIcon from "../../icons/Look.svg";
import ProceedIcon from "../../icons/Proceed.svg";
import { useCallback, useContext, useEffect, useState } from "react";
import {
  ActionType,
  AppContext,
  FocusedObjectIcon,
  FocusedObjectType,
  ModalType,
} from "../../contexts/AppContext";
import { useFollowObject } from "../../util/three-utils";
import classNames from "classnames";
import DeviceGradeDetection from "../../util/DeviceGradeDetection";

const ObjectStickyLabel = () => {
  const { state, dispatch } = useContext(AppContext);
  const { focusedObject } = state;
  const position = useFollowObject(focusedObject[0]);
  const [isVisible, setIsVisible] = useState(false);
  const [currentText, setCurrentText] = useState("");
  const [currentIcon, setCurrentIcon] = useState(FocusedObjectIcon.Eye);

  const activate = useCallback(() => {
    if (!focusedObject[0]) return;
    const { name, type } = focusedObject[0];

    if (type === FocusedObjectType.Plant) {
      (window as any).webGlView.scene.disableControls();
      dispatch({
        type: ActionType.HitPlant,
        value: name.replace("Placeholder_Plant_", ""),
      });
      dispatch({
        type: ActionType.SetModal,
        value: {
          type: ModalType.Plant,
          name: name.replace("Placeholder_Plant_", ""),
        },
      });
    } else if (type === FocusedObjectType.Look) {
      (window as any).webGlView.scene.disableControls();
      dispatch({
        type: ActionType.SetModal,
        value: {
          type: ModalType.Look,
          name: name.replace("Placeholder_Look_", ""),
        },
      });
    }
  }, [focusedObject]);

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === " ") {
        activate();
      }
    },
    [focusedObject]
  );

  useEffect(() => {
    if (focusedObject[0]) {
      const { name, icon, type } = focusedObject[0];
      setIsVisible(true);
      switch (type) {
        case FocusedObjectType.Look:
          if (DeviceGradeDetection.isMobile) {
            setCurrentText("View Look");
          } else {
            setCurrentText("Press Spacebar<br />To View Look");
          }
          break;
        case FocusedObjectType.World:
          setCurrentText(`Proceed to visit<br />${name}`);
          break;
        case FocusedObjectType.Plant:
          if (DeviceGradeDetection.isMobile) {
            setCurrentText("Collect Plant");
          } else {
            setCurrentText("Press Spacebar<br />To Collect Plant");
          }
          break;
      }
      setCurrentIcon(icon);
      window.addEventListener("keydown", onKeyDown);
    } else {
      setIsVisible(false);
    }

    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [focusedObject]);

  const { x, y } = position;
  return (
    <div
      style={{ transform: `translate3d(${x}px, ${y}px, 0)` }}
      aria-hidden={!isVisible}
      onClick={activate}
      className={classNames(classes.root, {
        [classes["root--is-visible"]]: isVisible,
      })}
    >
      <span className={classes.inner}>
        {(() => {
          switch (currentIcon) {
            case FocusedObjectIcon.CoralLagoon:
            case FocusedObjectIcon.FieldTrip:
            case FocusedObjectIcon.FungiForest:
              return <ProceedIcon alt="" />;
            case FocusedObjectIcon.Eye:
              return <LookIcon alt="" />;
          }
        })()}
        <span dangerouslySetInnerHTML={{ __html: currentText }}></span>
      </span>
    </div>
  );
};
export default ObjectStickyLabel;
